import React from 'react';
import { object } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown/with-html';

const Container = styled.div`
  width: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 5px;
`;

const Image = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-bottom: 8px;
`;

const Description = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    color: #4a4a4a;
  }

  strong {
    font-weight: bold;
  }

  a {
    color: #9027b0;
    text-decoration: none;
  }
`;

const SmallText = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
    color: #4a4a4a;
  }

  a {
    color: #9027b0;
    text-decoration: none;
  }
`;

const ReasonItem = ({ reason }) => (
  <Container>
    <Image src={`${process.env.PUBLIC_URL}/images/${reason.icon}.svg`} alt={reason.description} />
    <Description escapeHtml={false}>{reason.description}</Description>
    {reason.small && <SmallText>{reason.small}</SmallText>}
  </Container>
);

export default ReasonItem;

ReasonItem.propTypes = {
  reason: object.isRequired,
};
